"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Anchor = void 0;
var react_1 = __importDefault(require("react"));
var Anchor = function (_a) {
    var children = _a.children, target = _a.target, _b = _a.href, href = _b === void 0 ? "#" : _b;
    return (react_1.default.createElement("a", { className: "text-blue no-underline hover:text-blue-dark hover:underline", href: href, target: target }, children));
};
exports.Anchor = Anchor;
